import { call, select } from 'redux-saga/effects';
import { pathSelector } from 'redux/saga/selectors';
import { doLoadInviteAFriend } from './InviteAFriend.saga';

export function* getToken() {
  const currentPath = yield select(pathSelector);
  // checks if the url is the invite a friend url
  if (/^(\/invite\/)/.test(currentPath)) {
    // Gets the final path from the url. This path is the token.
    return /[^/]*$/.exec(currentPath)[0];
  }
}

export function* loadSaga(client) {
  const token = yield call(getToken);
  yield call(doLoadInviteAFriend, client, { token });
}
